import { type UserConsent } from '../../shared/types/userConsent';

const SERVICE_NAMES = {
    GOOGLE_CUSTOM_AUDIENCE: 'Google Custom Audience',
    META_CUSTOM_AUDIENCE: 'Meta Custom Audience',
};

export const getUserConsent = (): UserConsent | undefined => {
    if (!window.UC_UI?.isInitialized()) {
        return undefined;
    }

    const services = window.UC_UI.getServicesBaseInfo();
    const serviceMap = new Map(services.map(service => [service.name, service.consent.status]));

    return {
        googleCustomAudience: serviceMap.get(SERVICE_NAMES.GOOGLE_CUSTOM_AUDIENCE) ?? false,
        metaCustomAudience: serviceMap.get(SERVICE_NAMES.META_CUSTOM_AUDIENCE) ?? false,
    };
};
